module.exports = __webpack_public_path__ + "static/media/icon.ac87eb87.png";


//////////////////
// WEBPACK FOOTER
// ./src/branding/current/icon.png
// module id = 803
// module chunks = 0